import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { observer } from 'mobx-react-lite'
import { ActiveColorsIndicator } from 'common/Prose/components/ActiveColorsIndicator/ActiveColorsIndicator'
import { computed } from 'mobx'
import { AlmanacEditorStateContext } from 'stores/EditorState'
import { useContext } from 'react'
import { HighlightColorPicker } from 'common/Prose/components/HighlightColorPicker/HighlightColorPicker'
import { DEFAULT_HIGHLIGHT_COLOR, NO_HIGHLIGHT_COLOR } from 'common/Prose/constants/colorOptions'
import { removeHighlightColor, setHighlightColor } from 'common/Prose/Commands/formatting/highlightColor'
import Styles from './DoubleActionButtons.module.scss'
import { SimpleDropdown } from '../SimpleDropdown/SimpleDropdown'
import { useHover } from '@react-aria/interactions'
import cx from 'classnames'
import { Tooltip } from 'components/Tooltip/Tooltip'
import { ChevronDown } from 'almanac-ui/icons/12'
import { IconName, ToolbarIcon } from 'common/Prose/Toolbar/ToolbarIcon'
import { IconButton } from 'components/IconButton/IconButton'

export const InlineHighlightColorButton = observer(() => {
  const view = useEditorView()
  const editorState = useContext(AlmanacEditorStateContext)
  const { hoverProps, isHovered } = useHover({})

  const activeHighlightColors =
    computed(() => editorState?.highlightColors && Array.from(editorState.highlightColors)).get() || []
  const hasNoHighlightColor = computed(
    () => activeHighlightColors.length === 1 && activeHighlightColors.includes(NO_HIGHLIGHT_COLOR),
  ).get()

  const setDefaultHighlightOrRemoveHighlight = () => {
    if (hasNoHighlightColor) {
      setHighlightColor(DEFAULT_HIGHLIGHT_COLOR, view)
    } else {
      removeHighlightColor(view)
    }
  }

  return (
    <div className={Styles.doubleActionButton}>
      <Tooltip label="Highlight color">
        <IconButton
          className={cx(Styles.directActionButton, { [Styles.hovered]: isHovered })}
          variant="tertiary"
          size="md"
          onPress={setDefaultHighlightOrRemoveHighlight}
          aria-label="Set inline highlight color"
          icon={() => (
            <div className={Styles.trigger}>
              <ToolbarIcon name={IconName.HighlightText} />
              <ActiveColorsIndicator colors={activeHighlightColors} className={Styles.activeHighlightColorsOverride} />
            </div>
          )}
        />
      </Tooltip>

      <SimpleDropdown
        buttonClassName={Styles.arrow}
        hasChevron={false}
        unStyledButton
        tooltip={{ label: 'Highlight color' }}
        placement="bottom"
        {...hoverProps}
      >
        <ChevronDown />
        <HighlightColorPicker view={view} activeColors={activeHighlightColors} />
      </SimpleDropdown>
    </div>
  )
})
